import Breadcrumb from "../../Component/Breadcrumb";
function AdmissionandWithdrawal() {
  return (
    <>
      <Breadcrumb>Prospects / Admission & Withdrawal </Breadcrumb>
      <div className="innersec vision_mission">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Admission & Withdrawal </h1>
            </div>
            <div className="col-lg-12">


              <h3>ADMISSION</h3>
              <ul class="ul-list">
                <li>The list of the children selected for admission will be published on the school notice board on the date given.</li>
                <li>The parents shall deposit the first installment of the fees at the time of admission.</li>
                <li>Admission of the selected children shall be taken on the assigned days. Those who fail to respond shall forfeit their chance.</li>
                <li>
                  The following documents are essential at the time of admission.
                  <ul>
                    <li>I. Birth Certificate from the competent authority, such as: Panchayat / Nagarpalika. No other Certificate from whatever source it be, will be accepted. (Only for LKG)</li>
                    <li>II. PEN Number is mandatory (Class I to XI)</li>
                    <li>III. Transfer Certificate & Character Certifcate from the school last attended.</li>
                    <li>IV. A Xerox copy of mark List (Report card) along with the original.</li>
                    <li>V. Medical Fitness Certificate, certified by physician in Govt. Service.</li>
                  </ul>
                </li>
                <li>Admission of the Student in the school will be on the basis of merit.</li>
                <li>For taking admission the parents of the Student must inevitably be present and sign the admission form.</li>
              </ul>

              <h3>Withdrawal</h3>
              <ul class="ul-list">
                <li>Applications for Transfer Certificate must be forwarded by the parent/guardian of the Student. Transfer Certificate will be issued only after the Student has paid all the dues and arrears towards the school.</li>
                <li>If a Student is leaving the school during the school year he/she will have to pay all the dues and fees for the whole of the year, for Transfer Certificate to be issued in his/her favor.</li>
              </ul>

              <h3>Examinations and Promotions</h3>
              <ul class="ul-list">
                <li>Annual promotions are decided through a system of continuous assessment throughout the year.</li>
                <li>The promotion of a Student will be on the aggregate basis.</li>
                <li>The mark obtained in the annual examinations alone will not determine the promotion of the Student. The total marks are divided among the Periodical Assessments, half yearly and annual examinations.</li>
                <li>If any Student does not show steady and consistent progress in studies, he/ she is not liable to be promoted. There will be no re-examination or examination out of schedule.</li>
                <li>No leave other than Medical leave will be sanctioned during the examination; medical leave is to be applied for when the leave is taken and supported by medical certificate. A fitness certificate also must be produced when the Student attends the class next. However, he/she will have to forgo the marks in the aggregate.</li>
                <li>Students detected in giving or obtaining or attempting to give or obtain unfair assistance at the examinations will be disqualified. Students shall not take any books, notes, papers etc. into examination hall.</li>
                <li>All cases of doubt regarding evaluation of answer papers and promotion test rests entirely at the discretion of the Principal.</li>
                <li>A Student who fails for two consecutive years in a class will automatically be disqualified for continuance of studies in this school.</li>
                <li>Annual promotion from class IX to X and XI to XII will be strictly according the rules and regulation of CBSE Board.</li>
              </ul>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default AdmissionandWithdrawal;
